import { render, staticRenderFns } from "./MyAddressSelectUK.vue?vue&type=template&id=6ac34515&"
import script from "./MyAddressSelectUK.vue?vue&type=script&lang=js&"
export * from "./MyAddressSelectUK.vue?vue&type=script&lang=js&"
import style0 from "./MyAddressSelectUK.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports